import {
    SET_VEHICLE_NUMBER,
    SAVE_VEHICLE_NUMBER,
    RESET_VEHICLE_SAVED,
    USER_LOGIN_FAILED,
    SET_EDITING_STATUS,
    USER_INFO_LOAD_STARTED,
    USER_INFO_LOAD_FINISHED,
    USER_INFO_LOAD_FAILED,
    SET_TECH_SEARCH_PROPERTY,
    SET_TECH_TRANSFER_TO_PROPERTY,
    GET_TECH_INFO_STARTED,
    GET_TECH_INFO_FINISHED,
    GET_TECH_INFO_FAILED,
    SET_TECH_SEARCH_TOP_MATCH,
    SET_USER_ID,
    SET_CURRENT_TECH_ID,
    SET_PRESENCE_DATA,
    SET_CHANNEL_DATA,
    SET_APPIAN_CHANNEL_DATA
} from 'constants/actionTypes';

export const setVehicleNumber = (vehicleNumber) => ({type: SET_VEHICLE_NUMBER, vehicleNumber});
export const saveVehicleNumber = (vehicleNumber) => ({type: SAVE_VEHICLE_NUMBER, vehicleNumber});
export const resetVehicleSaved = () => ({type: RESET_VEHICLE_SAVED});
export const userLoginFailed = (payload) => ({type: USER_LOGIN_FAILED, payload});
export const setEditingStatus = (isEditing) => ({type: SET_EDITING_STATUS, isEditing});
export const userInfoLoadStarted = () => ({type: USER_INFO_LOAD_STARTED});
export const userInfoLoadFinished = (payload) => ({type: USER_INFO_LOAD_FINISHED, payload});
export const userInfoLoadFailed = (payload) => ({type: USER_INFO_LOAD_FAILED, payload});
export const setTechSearchProperty = (searchId) => ({type: SET_TECH_SEARCH_PROPERTY, searchId});
export const setTechTransferToProperty = (toTechId) => ({type: SET_TECH_TRANSFER_TO_PROPERTY, toTechId});
export const getTechInfoStarted = (id) => ({type: GET_TECH_INFO_STARTED, id});
export const getTechInfoFinished = (payload) => ({type: GET_TECH_INFO_FINISHED, payload});
export const getTechInfoFailed = (payload) => ({type: GET_TECH_INFO_FAILED, payload});
export const setTechSearchTopMatch = (userId) => ({type: SET_TECH_SEARCH_TOP_MATCH, userId});
export const setUserId = (userId) => ({type: SET_USER_ID, userId});
export const setCurrentTechId = (techId) => ({type: SET_CURRENT_TECH_ID, techId});
export const setPresenceData = (data) => ({type: SET_PRESENCE_DATA, data});
export const setChannelData = (data) => ({type: SET_CHANNEL_DATA, data});
export const setAppianChannelData = (data) => ({type: SET_APPIAN_CHANNEL_DATA, data});



// WEBPACK FOOTER //
// ./src/actions/userActions.js